// API base URL. In production this points at the DO-routed `/v1` prefix
// (the same base the Angular admin uses). For local dev, Vite proxies `/v1`
// to a locally-running API, so the relative default works without CORS.
export const API_BASE_URL: string =
  import.meta.env.VITE_API_BASE_URL ??
  (import.meta.env.DEV ? '/v1' : 'https://api.checkidapp.com/v1');
